<template>
  <div v-bind:class="{ 'advanced': isAdvanced }">
    <dede-header></dede-header>
    <cover :profile="data.cover.profile"></cover>
    <projects :title="data.projects.title" :projects="data.projects.items"></projects>
    <contact></contact>
    <dede-footer></dede-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import DedeHeader from "@/components/header/header.vue";
import Cover from "@/components/cover/cover.vue";
import Projects from "@/components/projects/projects.vue";
import Contact from "@/components/contact/contact.vue";
import DedeFooter from "@/components/footer/footer.vue";

let dedeData = require("@/data/index.json");
import webpImage from "@/assets/mckayla-crump-675004-unsplash-edit.webp";

export default {
  data: function() {
    if (process.env.NODE_ENV === "development") console.log(dedeData);
    return {
      data: dedeData,
      isAdvanced: false
    };
  },
  components: {
    DedeHeader,
    Cover,
    Projects,
    Contact,
    DedeFooter
  },
  created: function() {
    var img = new Image();
    var vm = this;
    img.onload = function() {
      vm.isAdvanced = img.height > 0 && img.width > 0;
    };
    img.onerror = function() {
      vm.isAdvanced = false;
    };
    img.src = webpImage;
  }
};
</script>
